import { Injectable } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { environment } from '@infra-env/environment';
import { IAppVersionCheckResponse } from '@core-ports/outputs/AppVersion';

@Injectable({ providedIn: 'root' })
export class AppVersionCheckService {
  async check(platform: 'ios' | 'android', version: string): Promise<IAppVersionCheckResponse> {
    const base = environment.apiUrl.replace(/\/graphql\/?$/, '');
    const url = `${base}/app-version/check`;
    const response = await CapacitorHttp.get({
      url,
      params: { platform, version },
      connectTimeout: 5000,
      readTimeout: 5000,
    });
    if (response.status < 200 || response.status >= 300) {
      throw new Error(`app-version-check ${response.status}`);
    }
    const data =
      typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
    return data as IAppVersionCheckResponse;
  }
}
